<template>
  <div class="bg-gray-900 rounded-lg shadow-lg p-8 text-center border border-gray-700">
    <!-- Phase Title -->
    <h1 class="text-4xl font-bold mb-2" :class="timeExpired ? 'text-red-400' : 'text-white'">
      {{ currentPhase.title }}
    </h1>
    
    <!-- Phase Info -->
    <p class="text-gray-300 mb-8">{{ currentPhase.description }}</p>
    
    <!-- Timer Display -->
    <div class="mb-8">
      <div 
        class="text-9xl md:text-12xl font-mono font-bold mb-6 timer-display" 
        :class="timeExpired ? 'text-red-400 timer-expired' : 'text-blue-400'"
        style="line-height: 0.8;"
      >
        {{ formatTime(remainingTime) }}
      </div>
      
      <!-- Progress Bar -->
      <div class="w-full bg-gray-700 rounded-full h-4 mb-4">
        <div 
          class="h-4 rounded-full transition-all duration-1000 progress-bar" 
          :style="{ width: progressPercentage + '%' }"
          :class="timeExpired ? 'bg-red-500' : 'bg-blue-500'"
        ></div>
      </div>
      
      <!-- Phase Counter -->
      <p class="text-lg text-gray-300">
        Fase {{ phaseDisplayNumber }} di {{ totalMainPhases }}
      </p>
    </div>
    
    <!-- Controls -->
    <div class="flex justify-center items-center gap-4 mb-6">
      <!-- Previous Button (subtle) -->
      <button 
        v-if="canGoPrevious" 
        @click="$emit('previous-phase')"
        class="px-4 py-2 text-sm text-gray-400 hover:text-gray-200 border border-gray-600 rounded-md hover:bg-gray-800 btn-secondary"
      >
        <i class="fas fa-arrow-left mr-2"></i>
        Precedente
      </button>
      
      <!-- Start/Pause Button -->
      <button 
        @click="$emit('toggle-timer')"
        class="px-8 py-4 text-xl font-bold text-white rounded-lg shadow-lg transition-all btn-primary"
        :class="isRunning ? 'bg-red-500 hover:bg-red-600' : 'bg-green-500 hover:bg-green-600'"
      >
        <i :class="isRunning ? 'fas fa-pause mr-2' : 'fas fa-play mr-2'"></i>
        {{ isRunning ? 'Pausa' : 'Start' }}
      </button>
      
      <!-- Next Button -->
      <button 
        @click="$emit('next-phase')"
        class="px-6 py-3 text-lg font-bold text-white bg-blue-500 hover:bg-blue-600 rounded-lg shadow-lg btn-primary"
      >
        Avanti
        <i class="fas fa-arrow-right ml-2"></i>
      </button>
    </div>
    
    <!-- Reset Button -->
    <button 
      @click="$emit('reset-phase')"
      class="px-4 py-2 text-sm text-gray-400 hover:text-gray-200 border border-gray-600 rounded-md hover:bg-gray-800 btn-secondary"
    >
      <i class="fas fa-redo mr-2"></i>
      Reset Fase
    </button>
  </div>
</template>

<script>
import { TimeUtils } from '@/utils/TimeUtils.js';

export default {
  name: 'TimerDisplay',
  props: {
    currentPhase: {
      type: Object,
      required: true
    },
    remainingTime: {
      type: Number,
      required: true
    },
    timeExpired: {
      type: Boolean,
      default: false
    },
    progressPercentage: {
      type: Number,
      default: 0
    },
    phaseDisplayNumber: {
      type: String,
      required: true
    },
    totalMainPhases: {
      type: Number,
      required: true
    },
    isRunning: {
      type: Boolean,
      default: false
    },
    canGoPrevious: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle-timer', 'next-phase', 'previous-phase', 'reset-phase'],
  setup() {
    const formatTime = TimeUtils.formatTime;
    
    return {
      formatTime
    };
  }
};
</script>